import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { shootToast } from "codekit";

import { useNavigateProcess } from "../../utils/hooks/useNavigateProcess";
import { setFunctionToExecute, setRetornoTablero } from "../../libs/redux/slices/trackingSlice/trackingSlice";
import { getModuleSelected, getProcesSelected } from "../../libs/redux/slices/MenuSlice/menuSlice";
import { WidgetContext } from "./Tarjewid";

/**
 * Drill-down único del kit de tableros: todo número lleva al tracking del
 * proceso con la consulta inducida (useNavigateProcess + filtros), o abre
 * un DO directo. Si el usuario no tiene el proceso en su menú, avisa.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 */
export function useDrilldown() {
  const dispatch = useDispatch();
  const { handleNavigateProcess } = useNavigateProcess();
  const moduloActual = useSelector(getModuleSelected);
  const procesoActual = useSelector(getProcesSelected);
  const widgetActual = useContext(WidgetContext);

  /** Filtro inducido "columna IN valores" del tracking genérico */
  const filtroIn = (columna, valores) => ({ [columna]: { IN: (Array.isArray(valores) ? valores : [valores]).map(String) } });

  /**
   * Abre el tracking del proceso (siempre la pantalla del sistema, nunca la
   * pestaña del puesto: Diego 2026-09-15) con los filtros inducidos y deja
   * registrado el origen para el botón "Volver al tablero"
   */
  const ir = (modulo, proceso, filtros = []) => {
    const origenEsInicio = !moduloActual?.MODURLXX || !procesoActual?.PRODURLX;
    dispatch(setRetornoTablero({
      target: `${modulo}.${proceso}`,
      origen: origenEsInicio ? { tipo: "INICIO" } : { tipo: "PROCESO", modulo: moduloActual.MODURLXX, proceso: procesoActual.PRODURLX },
      etiqueta: origenEsInicio ? "Volver al Inicio" : `Volver a ${procesoActual.PRODESXX || procesoActual.description || "tablero"}`,
      widget: widgetActual?.GRAIDXXX ?? null,
      enDestino: true,
      stamp: Date.now(),
    }));
    const bNavego = handleNavigateProcess(modulo, proceso, filtros, { soloProceso: true });
    if (!bNavego) {
      dispatch(setRetornoTablero(null));
    }
    if (!bNavego) {
      shootToast({ variant: "info", text: "No tiene esa pantalla en su menú", duration: 3000, autoHide: true });
    }
    return bNavego;
  };

  /** Abre directo la ficha del DO de importación (flujo External de Trackimp) */
  const abrirDo = (docnroxx) => {
    const filtros = [filtroIn("MDOSYYYY.DOCNROXX", docnroxx)];
    dispatch(setFunctionToExecute({ execute: true, functionName: "handleToggleEdit", ciacidxx: filtros, selector: {} }));
    return ir("Modimpxx", "Trackimp", filtros);
  };

  return { ir, filtroIn, abrirDo };
}

export default useDrilldown;
